import { useState, useEffect, useContext } from "react";
import { CustomButton, RegularButton } from "../../../common/ReusableComponent/CustomButton";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import ReusableModal from "../../AppPAges/ManageSettings/ReusableModal";
import PaginatedSearchSelect from "../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import { useToastHandler } from "../../../common/ToastHandler";
import useSwal from "../../../common/ReusableComponent/useSwal";
import { ReusableInput } from "../../../common/ReusableComponent/ReusableInput";
import AssetTable from "../AssetsInventory/AssetTable";
import AddVendorModal from "../../AppPAges/ReusableForm/AddVendorModal";
import "./RFQManagement.css"
import { FaEye, FaPaperPlane } from "react-icons/fa";
import LoadingOverlay from "../../../common/LoadingBar.js";
import loader from "../../../../assets/Image/Loader2.gif";
import CreateRfqIcon from "../../../../assets/Image/createRfq.png";
import StatusPill from "../../../common/ReusableComponent/StatusPill";
import ActionButton from "../../../common/ReusableComponent/ActionButton";
import { FaTrash } from "react-icons/fa";
const RFQManagement = () => {
  const { user } = useContext(AuthContext);
  const storeId = user.store;
  const { GetPaginatedData, Post, Delete, getAPI, Get } = useApi();
  const { handleToast } = useToastHandler();
  const { confirmDelete } = useSwal();
  const [showModal, setShowModal] = useState(false);
  const [rfqList, setRfqList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [refresh, setRefresh] = useState(0);
  const [showItemModal, setShowItemModal] = useState(false);
  const [showSendToVendorModal, setShowSendToVendorModal] = useState(false);
  const [showAddVendorModal, setShowAddVendorModal] = useState(false);
  const [selectedRfqId, setSelectedRfqId] = useState(null);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [vendorSelectValue, setVendorSelectValue] = useState(null);
  const [viewRfqId, setViewRfqId] = useState(null);
  const [rfqDetails, setRfqDetails] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [manualEmailInput, setManualEmailInput] = useState("");
  const [manualEmails, setManualEmails] = useState([]);

  const [rfqItems, setRfqItems] = useState([
    { product_name: "", specification: "", quantity: 1 }
  ]);

  const [errors, setErrors] = useState({
    asset_request: "",
    product_name: {},
    specification: {},
    quantity: {},
    manualEmailInput: ""
  });

  const [formData, setFormData] = useState({
    asset_request: "",
    asset_request_name: "",
    rfq_name: "",
    status: "draft",
    created_by: user.user_id,
    created_by_name: user.user_name || ""
  });

  const fetchRFQs = async () => {
    try {
      setLoading(true);
      const res = await GetPaginatedData("rfq", {
        page: currentPage,
        search: debouncedSearchTerm || undefined
      });

      setRfqList(res?.data || []);
      setTotalCount(res?.totalCount || 0);
    } catch {
      handleToast({ type: "ERROR", message: "Failed to fetch RFQs" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    fetchRFQs();
  }, [currentPage, debouncedSearchTerm, refresh]);

  const validateRfqForm = () => {
    let newErrors = {};

    const hasAssetRequest = !!formData.asset_request;
    const hasRfqName = !!formData.rfq_name?.trim();

    if (!hasAssetRequest && !hasRfqName) {
      newErrors.asset_request = "Select Asset Request or enter RFQ Name";
      newErrors.rfq_name = "Enter RFQ Name or select Asset Request";
      setErrors(prev => ({ ...prev, ...newErrors }));
      return false;
    }


    setErrors(prev => ({
      ...prev,
      asset_request: "",
      rfq_name: ""
    }));

    return true;
  };


  const handleRfqSubmit = async (e) => {
    e.preventDefault();
    if (!validateRfqForm()) return;

    const payload = {
      asset_request: formData.asset_request || null,
      rfq_name: formData.rfq_name,
      store: storeId,
      status: "draft",
      created_by: user.user_id,
      created_by_name: user.user_name || "",
      items: rfqItems.map(item => ({
        product_name: item.product_name,
        specification: item.specification,
        quantity: item.quantity
      }))
    };

    try {
      setCreateLoading(true);
      await Post("rfq", payload);
      handleToast({ type: "SUCCESS", message: "RFQ created" });
      setShowModal(false);
      resetRfqForm();
      setRefresh((p) => p + 1);
    } catch {
      handleToast({ type: "ERROR", message: "Failed to create RFQ" });
    } finally {
      setCreateLoading(false);
    }
  };

  const handleSendClick = (id) => {
    setSelectedRfqId(id);
    setShowSendToVendorModal(true);
  };


  const handleVendorSelect = (vendor) => {
    if (!vendor) return;

    if (vendor.id === "add-vendor") {
      setShowAddVendorModal(true);
      return;
    }

    const newVendor = {
      vendor_id: vendor.id,
      vendor_name: vendor.name || vendor.vendor_name,
      vendor_email: vendor.email || vendor.vendor_email,
      vendor_department_id: vendor.vendor_department_service?.[0] || null,
      vendor_department_name: vendor.vendor_department_service_title?.[0] || null
    };

    setSelectedVendors((prev) => {

      if (prev.some(v => v.vendor_id === newVendor.vendor_id)) {
        return prev;
      }
      return [...prev, newVendor];
    });
  };

  const handleVendorAdded = (newVendor) => {
    setShowAddVendorModal(false);

    // Force refresh of PaginatedSearchSelect
    setVendorSelectValue({ refresh: Date.now() });
    setTimeout(() => setVendorSelectValue(null), 100);

    // Show success message
    handleToast({ type: "SUCCESS", message: "Vendor added successfully. You can now select it from the dropdown." });
  };

  const removeVendor = (vendorId) => {
    setSelectedVendors(prev => prev.filter(v => v.vendor_id !== vendorId));
  };


  const handleSendToVendors = async () => {
    if (selectedVendors.length === 0 && manualEmails.length === 0) {
      handleToast({
        type: "ERROR",
        message: "Please select vendor or add email"
      });
      return;
    }

    try {
      setSendLoading(true);
      const payload = {
        vendors: selectedVendors.map(v => ({
          vendor_id: v.vendor_id,
          vendor_name: v.vendor_name,
          vendor_email: v.vendor_email,
          vendor_department_id: v.vendor_department_id,
          vendor_department_name: v.vendor_department_name
        })),
        manual_emails: manualEmails
      };

      const apiUrl = getAPI('rfqSendToVendors').replace('{id}', selectedRfqId);
      await Post(apiUrl, payload);

      handleToast({ type: "SUCCESS", message: "RFQ sent successfully" });

      setShowSendToVendorModal(false);
      setSelectedVendors([]);
      setManualEmails([]);
      setManualEmailInput("");
      setRefresh(p => p + 1);

    } catch {
      handleToast({ type: "ERROR", message: "Failed to send RFQ" });
    } finally {
      setSendLoading(false);
    }
  };


  const handleDelete = async (id) => {
    const res = await confirmDelete("Delete RFQ?", "This cannot be undone");
    if (!res.isConfirmed) return;

    try {
      await Delete("rfq", id);
      handleToast({ type: "SUCCESS", message: "RFQ deleted" });
      setRefresh((p) => p + 1);
    } catch {
      handleToast({ type: "ERROR", message: "Delete failed" });
    }
  };

  const addItemRow = () => {
    setRfqItems((prev) => [
      ...prev,
      { product_name: "", specification: "", quantity: 1 }
    ]);
  };
  const removeItemRow = (index) => {
    setRfqItems((prev) => prev.filter((_, i) => i !== index));
  };

  const updateItemField = (index, field, value) => {
    setRfqItems((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );

    if (errors[field] && errors[field][index]) {
      setErrors(prev => ({
        ...prev,
        [field]: { ...prev[field], [index]: "" }
      }));
    }
  };
  const validateRfqItems = () => {
    let isValid = true;
    const newErrors = { product_name: {}, specification: {}, quantity: {} };

    rfqItems.forEach((item, index) => {
      if (!item.product_name.trim()) {
        newErrors.product_name[index] = "Product name is required";
        isValid = false;
      } else if (item.product_name.length > 100) {
        newErrors.product_name[index] = "Product name must not exceed 100 characters";
        isValid = false;
      }

      if (!item.specification.trim()) {
        newErrors.specification[index] = "Specification is required";
        isValid = false;
      } else if (item.specification.length > 500) {
        newErrors.specification[index] = "Specification must not exceed 500 characters";
        isValid = false;
      }

      if (!item.quantity || item.quantity < 1) {
        newErrors.quantity[index] = "Quantity must be at least 1";
        isValid = false;
      }
    });

    setErrors(prev => ({ ...prev, ...newErrors }));
    return isValid;
  };

  const handleAddItemSubmit = async (e) => {
    e.preventDefault();
    if (!validateRfqItems()) return;
    if (!selectedRfqId) return;

    try {
      await Promise.all(
        rfqItems.map((item) =>
          Post("rfqitem", {
            store: storeId,
            rfq: selectedRfqId,
            product_name: item.product_name,
            specification: item.specification,
            quantity: item.quantity
          })
        )
      );

      handleToast({ type: "SUCCESS", message: "RFQ Items added" });
      setShowItemModal(false);
      resetRfqItems();
    } catch {
      handleToast({ type: "ERROR", message: "Failed to add RFQ items" });
    }
  };


  const handleViewClick = (rfqId) => {
    setViewRfqId(rfqId);
    setShowViewModal(true);
  };

  const fetchRfqById = async () => {
    if (!viewRfqId) return;

    try {
      setLoading(true);
      const res = await Get("rfq");
      const rfq = res?.results?.find(r => r.id === viewRfqId);

      if (!rfq) {
        throw new Error("RFQ not found");
      }

      setRfqDetails(rfq);
      console.log("RFQ DETAILS:", rfq);

    } catch (err) {
      console.error("RFQ FETCH ERROR:", err);
      handleToast({ type: "ERROR", message: "Failed to fetch RFQ details" });
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (showViewModal && viewRfqId) {
      fetchRfqById();
    }
  }, [showViewModal, viewRfqId]);
  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const addManualEmail = () => {
    if (!manualEmailInput.trim()) {
      setErrors(prev => ({ ...prev, manualEmailInput: "Email is required" }));
      return;
    }

    const emails = manualEmailInput
      .split(",")
      .map(e => e.trim())
      .filter(e => validateEmail(e));

    if (emails.length === 0) {
      setErrors(prev => ({ ...prev, manualEmailInput: "Please enter valid email addresses" }));
      return;
    }

    setManualEmails(prev => {
      const merged = [...prev, ...emails];
      return [...new Set(merged)];
    });

    setManualEmailInput("");
    setErrors(prev => ({ ...prev, manualEmailInput: "" }));
  };



  const resetRfqItems = () => {
    setRfqItems([{ product_name: "", specification: "", quantity: 1 }]);
    setSelectedRfqId(null);
  };


  const resetRfqForm = () => {
    setFormData({
      asset_request: "",
      asset_request_name: "",
      rfq_name: "",
      status: "draft",
      created_by: user.user_id,
      created_by_name: user.user_name || ""
    });
    setRfqItems([
      {
        product_name: "",
        specification: "",
        quantity: 1,

      }
    ]);
    setErrors({
      asset_request: "",
      product_name: {},
      specification: {},
      quantity: {},
      manualEmailInput: ""
    });
  };

  const handleBlur = (e, index = null) => {
    const { name, value } = e.target;
    let error = "";

    if (name === "product_name") {
      if (!value.trim()) {
        error = "Product name is required";
      } else if (value.length > 100) {
        error = "Product name must not exceed 100 characters";
      }
      setErrors(prev => ({
        ...prev,
        product_name: { ...prev.product_name, [index]: error }
      }));
    }

    if (name === "specification") {
      if (!value.trim()) {
        error = "Specification is required";
      } else if (value.length > 500) {
        error = "Specification must not exceed 500 characters";
      }
      setErrors(prev => ({
        ...prev,
        specification: { ...prev.specification, [index]: error }
      }));
    }

    if (name === "quantity") {
      if (!value || value < 1) {
        error = "Quantity must be at least 1";
      }
      setErrors(prev => ({
        ...prev,
        quantity: { ...prev.quantity, [index]: error }
      }));
    }

    if (name === "manualEmailInput") {
      if (value && !validateEmail(value)) {
        error = "Please enter a valid email address";
      }
      setErrors(prev => ({ ...prev, manualEmailInput: error }));
    }
  };


  const RFQ_STATUS_PILL = {
    draft: {
      bg: "#fff3cd",
      text: "#856404",
      border: "#ffeeba",
    },
    sent: {
      bg: "#e9fdf3",
      text: "#12b76a",
      border: "#a6f4c5",
    },
    closed: {
      bg: "#fdecec",
      text: "#e11d48",
      border: "#fda4af",
    },
  };

  const BTN = {
    add: {
      bg: "#eef2ff",
      text: "#4338ca",
      border: "#c7d2fe",
      hover: "#e0e7ff",
    },
    view: {
      bg: "#ecfeff",
      text: "#0891b2",
      border: "#bae6fd",
      hover: "#cffafe",
    },
    send: {
      bg: "#fff7ed",
      text: "#ea580c",
      border: "#fed7aa",
      hover: "#ffedd5",
    },
  };



  const columns = [
    { header: "RFQ Number", field: "rfq_number" },
    { header: "RFQ Name", field: "rfq_name" },
    { header: "Created By", field: "created_by_name" },

    {
      header: "Status",
      render: (row) => {
        const status = row.status || "draft";
        const cfg = RFQ_STATUS_PILL[status] || RFQ_STATUS_PILL.draft;

        return (
          <StatusPill
            label={status}
            bgColor={cfg.bg}
            textColor={cfg.text}
            borderColor={cfg.border}
          />
        );
      }
    },

    {
      header: "View",
      render: (row) => (
        <ActionButton
          onClick={() => handleViewClick(row.id)}
          bgColor={BTN.view.bg}
          textColor={BTN.view.text}
          borderColor={BTN.view.border}
          hoverBgColor={BTN.view.hover}
        >
          <FaEye />
          View
        </ActionButton>
      )
    },
    {
      header: "Send to Vendor",
      render: (row) => {
        if (row.status === "sent" || row.status === "closed") {
          return "-";
        }

        return (
          <ActionButton
            onClick={() => handleSendClick(row.id)}
            bgColor={BTN.send.bg}
            textColor={BTN.send.text}
            borderColor={BTN.send.border}
            hoverBgColor={BTN.send.hover}
          >
            <FaPaperPlane />
            Send To Vendor
          </ActionButton>
        );
      },
    },


  ];

  return (
    <div className="responsive-box">
      {sendLoading && (
      <LoadingOverlay loading={loading} loader={loader} />
      )}
      <div className="inventory-header">
        <div className="inventory-title">RFQ Management</div>
        <CustomButton
          text="Create RFQ"
          icon={CreateRfqIcon}
          onClick={() => setShowModal(true)}
          backgroundColor="#FFAF32"
        />
      </div>

      <ReusableModal
        title="Create RFQ"
        show={showModal}
        handleClose={() => {
          setShowModal(false);
          resetRfqForm();
        }}
        width="1000px"
      >
        <form onSubmit={handleRfqSubmit}>
          <div className="d-flex flex-column mx-3">
            <div className="d-flex gap-3 mb-3">
              <div className="d-flex flex-column" style={{ flex: 1 }}>
                <PaginatedSearchSelect
                  api="assetRequest"
                  GetPaginatedData={GetPaginatedData}
                  getOptionLabel={(o) => o.requested_for}
                  onSelect={(o) => {
                    setFormData((prev) => ({
                      ...prev,
                      asset_request: o?.id || "",
                      asset_request_name: o?.requested_for || ""
                    }));
                    if (errors.asset_request) {
                      setErrors(prev => ({ ...prev, asset_request: "" }));
                    }
                  }}
                  value={
                    formData.asset_request
                      ? { id: formData.asset_request, requested_for: formData.asset_request_name }
                      : null
                  }
                  placeholder="Select Asset Request *"
                  error={errors.asset_request}
                  style={{ width: "100%" }}
                />
                {errors.asset_request && (
                  <div className="text-danger" style={{ fontSize: "12px", marginTop: "4px" }}>
                    {errors.asset_request}
                  </div>
                )}
              </div>
              <div style={{ flex: 1 }}>
                <ReusableInput
                  type="text"
                  name="rfq_name"
                  label="RFQ Name"
                  value={formData.rfq_name}
                  onChange={(e) => {
                    setFormData(prev => ({
                      ...prev,
                      rfq_name: e.target.value,
                      asset_request: "",
                      asset_request_name: ""
                    }));
                    if (errors.rfq_name) {
                      setErrors(prev => ({ ...prev, rfq_name: "" }));
                    }
                  }}
                  error={errors.rfq_name}
                  style={{ width: "400px" }}
                />
              </div>
            </div>

            {/* ===== RFQ ITEMS TABLE ===== */}
            <h6 className="mt-2">RFQ Items</h6>

            {rfqItems.map((item, index) => (
              <div
                key={index}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  paddingTop: "30px",
                  paddingBottom: "30px",
                  marginBottom: "10px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  backgroundColor: "#f9f9f9",
                  display: "flex",
                  gap: "15px",
                  alignItems: "flex-start",
                }}
              >
                <ReusableInput
                  value={item.product_name}
                  label="Product Name"
                  name="product_name"
                  onChange={(e) =>
                    updateItemField(index, "product_name", e.target.value)
                  }
                  error={errors.product_name[index]}
                  style={{ flex: 1 }}
                  required
                />
                <ReusableInput
                  type="number"
                  min="1"
                  label="Quantity"
                  value={item.quantity}
                  onChange={(e) =>
                    updateItemField(index, "quantity", Number(e.target.value))
                  }
                  error={errors.quantity[index]}

                />
                <ReusableInput
                  type="textarea"
                  rows={1}
                  name="specification"
                  label="Specification"
                  value={item.specification}
                  onChange={(e) =>
                    updateItemField(index, "specification", e.target.value)
                  }
                  error={errors.specification[index]}
                  style={{ flex: 1 }}
                />
                {rfqItems.length > 1 && (
                  <button
                    type="button"
                    className="remove-item-icon"
                    onClick={() => removeItemRow(index)}

                  >
                    <FaTrash />
                  </button>
                )}
              </div>
            ))}

            <div className="add-product-container">
              <button
                type="button"
                className="add-product-btn"
                onClick={addItemRow}
              >
                <span className="add-icon">+</span>
                Add Product
              </button>
            </div>

            <div className="d-flex justify-content-end mt-3">
              <RegularButton text="Cancel" onClick={() => setShowModal(false)} backgroundColor="#ffffff" color="#282E26" />
              <RegularButton
                text={createLoading ? "Creating..." : "Create"}
                type="submit"
                backgroundColor="#282e26"
                disabled={createLoading}
              />
            </div>
          </div>
        </form>
      </ReusableModal>

      <ReusableModal
        title="Add RFQ Items"
        show={showItemModal}
        handleClose={() => setShowItemModal(false)}
        width="900px"
      >
        <form onSubmit={handleAddItemSubmit}>
          <div className="rfq-items-wrapper">

            <table className="rfq-items-table">
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Quantity</th>
                  <th>Specification</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {rfqItems.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <ReusableInput
                        type="text"
                        value={item.product_name}
                        onChange={(e) =>
                          updateItemField(index, "product_name", e.target.value)
                        }
                        onBlur={(e) => handleBlur(e, index)}
                        maxLength={100}
                        required
                        error={errors.product_name[index]}
                      />
                    </td>

                    <td className="qty-cell">
                      <ReusableInput
                        type="number"
                        min="1"
                        value={item.quantity}
                        onChange={(e) =>
                          updateItemField(index, "quantity", Number(e.target.value))
                        }
                        onBlur={(e) => handleBlur(e, index)}
                        required
                        error={errors.quantity[index]}
                      />
                    </td>

                    <td>
                      <ReusableInput
                        type="textarea"
                        rows={2}
                        value={item.specification}
                        onChange={(e) =>
                          updateItemField(index, "specification", e.target.value)
                        }
                        onBlur={(e) => handleBlur(e, index)}
                        maxLength={500}
                        required
                        error={errors.specification[index]}
                      />
                    </td>

                    <td className="action-cell">
                      <button
                        type="button"
                        className="remove-btn"
                        onClick={() => removeItemRow(index)}
                        title="Remove"
                      >
                        ✕
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button
              type="button"
              className="add-row-btn"
              onClick={addItemRow}
            >
              + Add Product
            </button>

            <div className="rfq-footer-actions">
              <RegularButton
                text="clear"
                onClick={resetRfqItems}
                backgroundColor="#ffffff"
                color="#282E26"
              />
              <RegularButton
                text="Save Items"
                type="submit"
                backgroundColor="#282e26"
              />
            </div>

          </div>
        </form>
      </ReusableModal>


      <ReusableModal
        title="Send RFQ to Vendors"
        show={showSendToVendorModal}
        handleClose={() => {
          setShowSendToVendorModal(false);
          setSelectedVendors([]);
        }}
        width="900px"
      >
        <div className="d-flex flex-column mx-3">
          <PaginatedSearchSelect
            key={vendorSelectValue?.refresh || 'vendor-select'}
            api="vendorDepartmentData"
            GetPaginatedData={GetPaginatedData}
            getOptionLabel={(opt) => `${opt.name} - ${opt.email || 'No email'}`}
            value={vendorSelectValue?.refresh ? null : vendorSelectValue}
            placeholder="Select Vendor"
            pageSize={10}
            filterFn={(vendor) =>
              vendor.type === "expense" &&
              !vendor.is_deleted &&
              !selectedVendors.some(v => v.vendor_id === vendor.id)
            }
            extraOptions={[{ id: "add-vendor", label: "Add Vendor" }]}
            onSelect={(vendor) => {
              if (!vendor) return;
              handleVendorSelect(vendor);
              setVendorSelectValue(null);
            }}
          />

          {selectedVendors.length > 0 && (
            <div style={{ marginTop: "20px", marginBottom: "20px" }}>
              <h6>Selected Vendors ({selectedVendors.length}):</h6>
              {selectedVendors.map(vendor => (
                <div key={vendor.vendor_id} style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px",
                  margin: "4px 0",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  backgroundColor: "#f8f9fa"
                }}>
                  <div>
                    <div style={{ fontWeight: "bold" }}>{vendor.vendor_name}</div>
                    <div style={{ fontSize: "12px", color: "#666" }}>{vendor.vendor_email}</div>
                  </div>
                  <button
                    onClick={() => removeVendor(vendor.vendor_id)}
                    style={{
                      background: "#dc3545",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      padding: "4px 8px",
                      cursor: "pointer",
                      fontSize: "12px"
                    }}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
          )}
          {/* Manual Emails */}
          {/* <div style={{ marginTop: "20px" }}>
            <label style={{ fontWeight: "bold", marginBottom: "6px", display: "block" }}>
              Additional Emails
            </label>

            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <div style={{ display: "flex", gap: "6px" }}>
                <input
                  type="text"
                  name="manualEmailInput"
                  placeholder="jitu@humbingo.com, jay@company.com"
                  value={manualEmailInput}
                  onChange={(e) => {
                    setManualEmailInput(e.target.value);
                    if (errors.manualEmailInput) {
                      setErrors(prev => ({ ...prev, manualEmailInput: "" }));
                    }
                  }}
                  onBlur={handleBlur}
                  style={{
                    flex: 1,
                    padding: "8px",
                    borderRadius: "4px",
                    border: errors.manualEmailInput ? "1px solid #dc3545" : "1px solid #ccc"
                  }}
                />

                <button
                  type="button"
                  onClick={addManualEmail}
                  style={{
                    backgroundColor: "#007bff",
                    color: "white",
                    border: "none",
                    padding: "8px 12px",
                    borderRadius: "4px",
                    cursor: "pointer"
                  }}
                >
                  Add
                </button>
              </div>
              {errors.manualEmailInput && (
                <div style={{ color: "#dc3545", fontSize: "12px" }}>
                  {errors.manualEmailInput}
                </div>
              )}
            </div>

            {manualEmails.length > 0 && (
              <div style={{ marginTop: "10px" }}>
                {manualEmails.map(email => (
                  <div
                    key={email}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "6px 10px",
                      marginBottom: "4px",
                      backgroundColor: "#f1f3f5",
                      borderRadius: "4px"
                    }}
                  >
                    <span>{email}</span>
                    <button
                      onClick={() => removeManualEmail(email)}
                      style={{
                        background: "transparent",
                        border: "none",
                        color: "#dc3545",
                        cursor: "pointer"
                      }}
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div> */}

          <div className="d-flex justify-content-end mt-3">
            <RegularButton
              text="Cancel"
              onClick={() => {
                setShowSendToVendorModal(false);
                setSelectedVendors([]);
              }}
              backgroundColor="#ffffff"
              color="#282E26"
            />
            <RegularButton
              text="Send to Vendors"
              onClick={handleSendToVendors}
              backgroundColor="#282e26"
              disabled={sendLoading}
            />
          </div>
        </div>
      </ReusableModal>
      <ReusableModal
        title="RFQ Details"
        show={showViewModal}
        handleClose={() => {
          setShowViewModal(false);
          setViewRfqId(null);
          setRfqDetails(null);
        }}
        width="800px"
      >
        {rfqDetails ? (
          <>
            {Array.isArray(rfqDetails.items) && rfqDetails.items.length > 0 ? (
              <table className="rfq-view-table">
                <thead className="rfq-view-thead">
                  <tr>
                    <th>Product Name</th>
                    <th>Specification</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody className="rfq-view-tbody">
                  {rfqDetails.items.map((item) => (
                    <tr key={item.id} className="rfq-view-row">
                      <td>{item.product_name}</td>
                      <td>{item.specification}</td>
                      <td>{item.quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No items</p>
            )}
          </>
        ) : (
          <p>Loading...</p>
        )}
      </ReusableModal>
      <AssetTable
        data={rfqList}
        columns={columns}
        loading={loading}
        showAction={true}
        showFooter={true}
        onDelete={handleDelete}
        currentPage={currentPage}
        totalCount={totalCount}
        onPageChange={setCurrentPage}
        searchTerm={searchTerm}
        onSearch={setSearchTerm}
      />

      <AddVendorModal
        show={showAddVendorModal}
        handleClose={() => setShowAddVendorModal(false)}
        onVendorAdded={handleVendorAdded}
      />
    </div>
  );
};

export default RFQManagement;
